import { t } from "i18next";
import { useEffect, useRef, useState } from "react";
import useCreateTestResult from "../../resultHooks/useCreateTestResult";
import { parseQuestions } from "../../utils/parseQuestions";
import Button from "../CustomButtons/Button";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import TestScoreSummery from "../TestScoreSummery";
import QuestionPalette from "./QuestionPalette";
import SectionPdfViewer from "./SectionPdfViewer";
export default function TestPlayer({ testAttemptDetails, onFinish }) {
    const questionsRef = useRef([]);
    console.log(testAttemptDetails, '-testAttemptDetails')
    const [sectionSummary, setSectionSummary] = useState(null);
    const result = useCreateTestResult();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const duration = testAttemptDetails && JSON.parse(testAttemptDetails?.attemptDetails)?.duration;
    const [questions, setQuestions] = useState(
        parseQuestions(testAttemptDetails?.attemptDetails)
    );

    // console.log(duration, "durations-", questions);

    const [timeLeft, setTimeLeft] = useState(duration * 60);
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    handleTestSubmit();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []); // run only once
    useEffect(() => {
        questionsRef.current = questions;
    }, [questions]);

    const formatTime = (sec) => {
        const hours = Math.floor(sec / 3600);
        const minutes = Math.floor((sec % 3600) / 60);
        const seconds = sec % 60;

        return `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    };

    const updateResponse = (questions, questionId, selectedOption) => {
        return questions.map((q) => {
            if (q.id === questionId) {
                const cleanedAnswer = q.answer?.trim();
                const cleanedResponse = selectedOption === null ? null : selectedOption?.trim();

                return {
                    ...q,
                    response: cleanedResponse,
                    isCorrect: cleanedAnswer === cleanedResponse,
                };
            }
            return q;
        });
    };

    const calculateTotalScore = (sections) => {
        return sections.reduce(
            (acc, sec) => {
                acc.total += sec.poolScore;
                acc.positive += sec.positiveScore;
                acc.negative += sec.negativeScore;
                return acc;
            },
            { total: 0, positive: 0, negative: 0 }
        );
    };
    const calculateSectionScores = (questions) => {
        const pools = {};

        questions.forEach((q) => {
            const poolId = q.poolId;

            if (!pools[poolId]) {
                pools[poolId] = {
                    id: poolId,
                    text: q.poolText,
                    correctResponses: 0,
                    incorrectResponses: 0,
                    points: q.points,
                    negativePoints: q.negativePoints,
                    maxQuestionForScore: q.maxQuestionForScore,
                    questionCount: q.questionCount,
                    positiveScore: 0,
                    negativeScore: 0,
                    poolScore: 0,
                    totalPoolScore: 0,
                };
            }

            const pool = pools[poolId];

            if (q.response != null) {
                if (q.isCorrect) {
                    pool.correctResponses++;
                } else {
                    pool.incorrectResponses++;
                }
            }
        });

        // Now calculate scores per pool
        Object.values(pools).forEach((pool) => {
            let correct = pool.correctResponses;
            let incorrect = pool.incorrectResponses;
            const points = pool.points;
            const negativePoints = pool.negativePoints;
            const max = pool.maxQuestionForScore;

            // Apply maxQuestionForScore logic
            if (max != null && max > 0) {

                if (correct >= max) {
                    correct = max;
                    incorrect = 0;
                }

                if ((correct + incorrect) > max) {
                    incorrect = max - correct;
                }
            }

            pool.positiveScore = correct * points;
            pool.negativeScore = incorrect * negativePoints;
            pool.poolScore = pool.positiveScore + pool.negativeScore;
            //BSS121 todo- need to handle pool level point calculation.
            pool.totalPoolScore =
                max != null && max > 0
                    ? max * points
                    : pool.questionCount * points;
        });

        return Object.values(pools);
    };

    // const calculateSectionScores = (questions) => {
    //     const pools = {};

    //     questions.forEach((q) => {
    //         console.log(q, '-pool')
    //         const poolId = q.poolId;

    //         if (!pools[poolId]) {
    //             pools[poolId] = {
    //                 id: poolId,
    //                 text: q.poolText,
    //                 poolScore: 0,
    //                 totalPoolScore: 0,
    //                 positiveScore: 0,
    //                 negativeScore: 0,
    //             };
    //         }

    //         const pool = pools[poolId];
    //         // pool.totalPoolScore += q.points;
    //         pool.totalPoolScore = q?.maxQuestionForScore !== null && q?.maxQuestionForScore !== 0 ? q?.maxQuestionForScore * q?.points : q?.questionCount * q?.points

    //         if (q.response !== null) {
    //             if (q.isCorrect) {
    //                 pool.positiveScore += q.points;
    //                 pool.poolScore += q.points;
    //             } else {
    //                 pool.negativeScore += q.negativePoints;
    //                 pool.poolScore += q.negativePoints;
    //             }
    //         }
    //     });

    //     return Object.values(pools);
    // };

    // update answer inside question object
    const handleAnswer = (id, value) => {
        // setQuestions(prev =>
        //     prev.map(q =>
        //         q.id === id ? { ...q, response: value } : q
        //     )
        // );
        setQuestions(prev =>
            updateResponse(prev, id, value)
        );
    };

    const handleTestSubmit = async () => {

        if (isSubmitted) return;
        setIsSubmitted(true);

        console.log(questions, '-attemptanswerspayload')
        const latestQuestions = questionsRef.current;
        const calculateSectionbasedScore = calculateSectionScores(latestQuestions)
        const totalScore = calculateTotalScore(calculateSectionbasedScore);
        let isPassed = JSON.parse(testAttemptDetails?.attemptDetails)?.passingScore == null ? null : totalScore && totalScore?.total >= JSON.parse(testAttemptDetails?.attemptDetails)?.passingScore ? true : false;
        console.log(calculateSectionbasedScore, '-sectionbasedScore', totalScore, '-toalSore')

        testAttemptDetails.isCourse = testAttemptDetails?.isCourse;
        testAttemptDetails.result = isPassed == null ? 3 : isPassed == true ? 2 : 1;
        testAttemptDetails.actualScore = totalScore?.total;    // calculatedActualScore;
        testAttemptDetails.negativeScore = totalScore?.negative; //  calculatedNegativeScore;
        testAttemptDetails.positiveScore = totalScore?.positive; //calculatedPositiveScore;
        testAttemptDetails.sectionScore = JSON.stringify(calculateSectionbasedScore);
        testAttemptDetails.attemptAnswers = JSON.stringify(latestQuestions);
        testAttemptDetails.attemptedOn = new Date()
        testAttemptDetails.updatedDate = new Date()
        testAttemptDetails.isSubmited = true;
        testAttemptDetails.courseId = testAttemptDetails?.courseId;
        // 
        console.log(duration, "durations-", questions, "latestQuestions", latestQuestions);

        console.log(testAttemptDetails, '-final Payload')
        await result.mutateAsync(testAttemptDetails);
        setSectionSummary(calculateSectionbasedScore);

    }
    // pdf section based start
    const sections = questions.reduce((acc, q) => {
        if (!acc[q.poolId]) {
            acc[q.poolId] = {
                poolText: q.poolText,
                pdfUrl: q.pdfUrl, // attach in parseQuestions if needed
            };
        }
        return acc;
    }, {});

    // pdf section based end
    const toggleMarkForReview = (id) => {
        setQuestions(prev =>
            prev.map(q =>
                q.id === id ? { ...q, markForReview: !q.markForReview } : q
            )
        );
    };
    return (
        <div style={styles.container}>
            {sectionSummary &&
                <>
                    <GridContainer
                        justifyContent="center"
                        alignItems="center"
                    >
                        <GridItem xs={12} sm={12} md={11} style={{ textAlign: "center" }}>
                            {
                                testAttemptDetails && testAttemptDetails?.result === 3 ?
                                    <h2 style={{ fontFamily: 'Poppins' }}>{"Result not applicable"}</h2> :
                                    testAttemptDetails?.actualScore >= test.masteryScore && testAttemptDetails?.result == 2 ?
                                        <h2 style={{ fontFamily: 'Poppins' }}>{testAttemptDetails && JSON.parse(testAttemptDetails?.attemptDetails)?.feedbackmastery}</h2> :
                                        testAttemptDetails?.actualScore >= test.passingScore && testAttemptDetails.result == 2 ?
                                            <h2 style={{ fontFamily: 'Poppins' }}>{testAttemptDetails && JSON.parse(testAttemptDetails?.attemptDetails)?.feedbackPass}</h2> :
                                            <h2 style={{ fontFamily: 'Poppins' }}>{testAttemptDetails && JSON.parse(testAttemptDetails?.attemptDetails)?.feedbackFail}</h2>
                            }
                            <h4 style={{ fontFamily: 'Poppins' }}>{`${t('feedbackScreen')}: ${testAttemptDetails && testAttemptDetails?.actualScore}/${testAttemptDetails?.totalScore}`}</h4>
                        </GridItem>
                        <GridItem xs={11} sm={11} md={11} style={{ textAlign: "center" }}>
                            <TestScoreSummery data={sectionSummary && sectionSummary} />
                            <Button
                                style={{
                                    backgroundColor: '#001124',
                                    fontFamily: 'Poppins',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    lineHeight: '1.38',
                                    borderRadius: '8px'
                                }}
                                onClick={() => onFinish()}>{t('ok')}</Button>
                        </GridItem>
                    </GridContainer>
                </>
            }
            {
                !sectionSummary && (
                    <>
                        {/* LEFT — PDF */}
                        <div style={styles.leftPane}>
                            {/* <PdfViewer fileUrl="/2025_1_English.pdf" /> */}
                            <SectionPdfViewer sections={sections} />
                        </div>

                        {/* RIGHT — QUESTIONS */}
                        <div style={styles.rightPane}>
                            {/* TIMER */}
                            <div style={styles.timerBox}>
                                <div style={styles.timerHeader}>
                                    {/* SUBMIT BUTTON */}
                                    <button
                                        style={styles.submitBtn}
                                        onClick={handleTestSubmit}
                                        disabled={isSubmitted}
                                    >
                                        Submit Test
                                    </button>
                                    <div style={styles.timer}>
                                        ⏳ {formatTime(timeLeft)}
                                    </div>
                                </div>
                            </div>

                            {/* QUESTIONS */}
                            <div style={{ flex: 1, overflowY: "auto" }}>
                                <QuestionPalette
                                    questions={questions}
                                    onAnswer={handleAnswer}
                                    onToggleReview={toggleMarkForReview}
                                />
                            </div>


                        </div>
                    </>
                )
            }
        </div>
    );
}
const styles = {
    container: {
        display: "flex",
        height: "85vh",
        overflowX: "hidden"
    },
    leftPane: {
        flex: 6,
        overflowY: "auto",
        borderRight: "1px solid #ddd",
    },
    rightPane: {
        flex: 4,
        display: "flex",
        flexDirection: "column",
    },
    timerBox: {
        padding: 16,
        borderBottom: "1px solid #ddd",
        background: "#fafafa",
    },

    timerHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },

    timer: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#d32f2f",
    },
    footer: {
        padding: 12,
        borderTop: "1px solid #ddd",
        background: "#fff",
    },
    submitBtn: {
        width: "40%",
        padding: "6px",
        fontSize: "16px",
        background: "#001124",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        cursor: "pointer",
        fontFamily: 'Poppins',
    },
};